import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Breadcrumbs,
  Button,
  Card,
  FormControl,
  IconButton,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Chip,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";
import { useStyles } from "../../theme/theme";
import AddOffer from "./AddOffer";
import EditOffer from "./EditOffer";
import { getAllOffersAction } from "../../redux/toolkit/offer/getAllOffers";
import { deleteOfferAction } from "../../redux/toolkit/offer/deleteOffer";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import DailogUi from "../../comman/DailogUi";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/offers"
      >
        Offers
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h4">
      Offers
    </Typography>
  </Stack>
);

const Offer = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const classes = useStyles();
  const dispatch = useDispatch();

  // Get initial values from URL params
  const initialPage = parseInt(searchParams.get("page")) || 0;
  const initialPageSize = parseInt(searchParams.get("pageSize")) || 25;
  const initialSearch = searchParams.get("search") || "";
  const initialPartnerId = searchParams.get("partner_id") || "";

  const [createOffer, setCreateOffer] = useState(false);
  const [editOfferShow, setEditOfferShow] = useState(false);
  const [offerId, setOfferId] = useState("");
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedOfferId, setSelectedOfferId] = useState("");
  const [snack, setSnack] = useState(false);
  
  const [pageState, setPageState] = useState({
    page: initialPage,
    pageSize: initialPageSize,
  });
  const [search, setSearch] = useState(initialSearch);
  const [partnerId, setPartnerId] = useState(initialPartnerId);

  const { data, message, totalPages, totalDocs, loading } = useSelector(
    (state) => state.getAllOffers
  );

  const { data: partnersData } = useSelector(
    (state) => state.allPartnerWithoutLimit
  );

  const deleteOfferSelector = useSelector((state) => state.deleteOffer);

  // Update URL params when filters change
  useEffect(() => {
    const params = {
      page: pageState.page.toString(),
      pageSize: pageState.pageSize.toString(),
    };
    if (search) params.search = search;
    if (partnerId) params.partner_id = partnerId;
    setSearchParams(params);
  }, [pageState.page, pageState.pageSize, search, partnerId, setSearchParams]);

  // Fetch data
  useEffect(() => {
    dispatch(
      getAllOffersAction({
        page: pageState.page,
        pageSize: pageState.pageSize,
        search: search,
        partner_id: partnerId,
      })
    );
  }, [pageState.page, pageState.pageSize, search, partnerId, dispatch]);

  // Fetch partners
  useEffect(() => {
    dispatch(getAllPartnerActionNoLimit());
  }, [dispatch]);

  // Handle snackbar for delete
  useEffect(() => {
    if (deleteOfferSelector.status === 200) {
      setSnack(true);
      setDeleteDialog(false);
      dispatch(
        getAllOffersAction({
          page: pageState.page,
          pageSize: pageState.pageSize,
          search: search,
          partner_id: partnerId,
        })
      );
    }
  }, [deleteOfferSelector.status]);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPageState((old) => ({ ...old, page: 0 }));
  };

  const handlePartnerChange = (event) => {
    setPartnerId(event.target.value);
    setPageState((old) => ({ ...old, page: 0 }));
  };

  const handleDeleteClick = (id) => {
    setSelectedOfferId(id);
    setDeleteDialog(true);
  };

  const handleDeleteConfirm = () => {
    dispatch(deleteOfferAction({ offerId: selectedOfferId }));
  };

  const columns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 80,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "name",
      headerName: "Offer Name",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "p_offer_id",
      headerName: "Offer ID",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "partner_id",
      headerName: "Partner",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.partner_id?.name || "N/A"}</Typography>;
      },
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
      minWidth: 120,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "total_payout_amount",
      headerName: "Total Payout",
      flex: 1,
      minWidth: 130,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.total_payout_amount || 0}</Typography>;
      },
    },
    {
      field: "attempts",
      headerName: "Attempts",
      flex: 1,
      minWidth: 100,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "completes",
      headerName: "Completes",
      flex: 1,
      minWidth: 100,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "is_active",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return params?.row?.is_active ? (
          <Chip label="Active" color="success" />
        ) : (
          <Chip label="Inactive" color="error" />
        );
      },
    },
    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
      minWidth: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return moment(params?.row?.created_at).format("DD-MM-YYYY hh:mm:ss A");
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      minWidth: 100,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setEditOfferShow(true);
              setOfferId(params?.row?._id);
            }}
            color="primary"
          >
            <EditIcon />
          </IconButton>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      minWidth: 100,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => handleDeleteClick(params?.row?._id)}
            color="error"
          >
            <DeleteIcon />
          </IconButton>
        );
      },
    },
  ];

  return (
    <>
      <Helmet>
        <title>Real Opinion Admin | Offers</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <Body>
        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
            mb: 2,
          }}
        >
          <Stack direction="row" spacing={2}>
            <TextField
              label="Search by Name or Offer ID"
              variant="outlined"
              size="small"
              value={search}
              onChange={handleSearchChange}
              sx={{ minWidth: 250 }}
            />
            
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel id="partner-filter-label">Filter by Partner</InputLabel>
              <Select
                labelId="partner-filter-label"
                value={partnerId}
                label="Filter by Partner"
                onChange={handlePartnerChange}
              >
                <MenuItem value="">All Partners</MenuItem>
                {partnersData?.map((partner) => (
                  <MenuItem key={partner._id} value={partner._id}>
                    {partner.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Button
            variant="contained"
            color="btn"
            startIcon={<AddIcon />}
            onClick={() => setCreateOffer(true)}
          >
            Create Offer
          </Button>
        </Stack>

        <Card sx={{ my: 2 }}>
          <Stack direction={"row"} alignItems="center" sx={{ ml: 1 }}>
            <Typography sx={{ my: 1 }} variant="h6">
              Offers List ({totalDocs || 0})
            </Typography>
          </Stack>

          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data || []}
              autoHeight
              columns={columns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                LoadingOverlay: () => <LoadingUI />,
              }}
              rowCount={totalDocs}
              paginationMode="server"
              page={pageState.page}
              pageSize={pageState.pageSize}
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>

        {createOffer && (
          <AddOffer
            state={createOffer}
            setState={setCreateOffer}
            pageState={pageState}
            search={search}
            partnerId={partnerId}
          />
        )}
        
        {editOfferShow && (
          <EditOffer
            offerId={offerId}
            state={editOfferShow}
            setState={setEditOfferShow}
            pageState={pageState}
            search={search}
            partnerId={partnerId}
          />
        )}

        {deleteDialog && (
          <DailogUi
            open={deleteDialog}
            setOpen={setDeleteDialog}
            title="Delete Offer"
            description="Are you sure you want to delete this offer? This action cannot be undone."
            onConfirm={handleDeleteConfirm}
            loading={deleteOfferSelector.loading}
          />
        )}

        {snack && (
          <SnackBarUI
            open={snack}
            setOpen={setSnack}
            message={deleteOfferSelector.message || ""}
            type={deleteOfferSelector.status === 200 ? "success" : "error"}
          />
        )}
      </Body>
    </>
  );
};

export default Offer;
